import { Injectable } from '@angular/core';
import { Ibge } from './../models/ibge';
import { Observable } from 'rxjs/Rx';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class IbgeService {

  constructor(private http: HttpClient) { }

  consultarPorEstado(estado: string) {
    return this.http.get<Ibge[]>(globals.apiUrl + '/api/Ibge/ListaUF',
      { params: new HttpParams().set('uf', estado) });
  }

  consultarPorCidade(cidade: string) {
    return this.http.get<Ibge[]>(globals.apiUrl + '/api/Ibge/ListaPorCidade',
      { params: new HttpParams().set('cidade', cidade) });
  }

  buscarCidadePorCodIGBE(ibge: string) {
    return this.http.get<Ibge>(globals.apiUrl + '/api/Ibge/BuscaCidadePorCodIBGE',
      { params: new HttpParams().set('cod', ibge) });
  }

  buscarCidades() {
    return this.http.get<any>(globals.apiUrl + '/api/Ibge/BuscarCidades');
  }

  consultarCidadesComPaginacao(cidade: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, cd?, estado?) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (cd !== null && cd !== undefined) {
      parametros = parametros.set('cd', cd);
    }

    if (cidade.trim() !== '') {
      parametros = parametros.set('cidade', cidade);
    }

    if (estado !== null && estado !== undefined) {
      parametros = parametros.set('estado', estado);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Ibge/ListaPag',
      {
        params: parametros
      });
  }

  exportar(cidade: string, estado?, cd?) {
    return this.http.post(globals.apiUrl + '/api/Ibge/Exportar',
      { cidade, cd, estado }, { responseType: 'blob' }
    );
  }

  importar(dados) {
    return this.http.post(globals.apiUrl + '/api/Ibge/Importar', dados);
  }
}
